export const ACCESS_TOKEN = 'accessToken';

export const COLORS = {
  WHITE: '#ffffff',
  GRAY100: '#D0D5DD',
  SECONDARY: '#5532FA',
  SUCCESS: '#49BC80',
};

export const NETWORK_ERROR = 'Network Error';
export const ERROR_STATUS_500 = 5;
export const ERROR_STATUS_401 = 401;
export const ERROR_STATUS_404 = 404;
export const ERROR_MESSAGE = 'Something went wrong!';

export const OPTIONAL_LABEL = 'Valinnainen';
export const WIDGET_PRO_LANGUAGE = 'fi';
export const NEWSLETTER_CONFIRM_EMAIL_NOTE =
  'Jos osoite on uusi, lähetämme vahvistusviestin. Tilaus alkaa, kun vahvistat sen.';

export const PLATFORM_OPTIONAL_LABELS = ['optional', 'valinnainen', 'valfritt'];

export const FIELD_TYPES = {
  UPLOAD: 'upload',
  NUMBER: 'number',
  DROPDOWN: 'dropdown',
  FILE: 'file',
  TEL: 'tel',
  EMAIL: 'email',
  TEXTAREA: 'textarea',
  DATE: 'date',
  CONSENT: 'consent',
};

export const MAX_FILE_SIZE = 10 * 1024 * 1024;

export const MAX_LENGTH_LIMIT = 100;

export const DELETED = 'DELETED';

export const MOBILE_BREAKPOINT = 576;

export const DATE_FORMAT = {
  STANDARD_TIME: 'HH:mm',
  RANGE_DATE: 'DD/MM/YYYY',
  STANDARD_DATE: 'YYYY-MM-DD',
};

export const RESET = 'reset';

export const CLOSE = 'close';

export const ENTER = 'Enter';

export const VIEW_MODES = {
  DESKTOP: 'desktop',
  MOBILE: 'mobile',
};

export const GRADIENT_DIRECTIONS = {
  VERTICAL: 'VERTICAL',
  HORIZONTAL: 'HORIZONTAL',
};

export const GRADIENT_DIRECTION_MAP = {
  VERTICAL: 'to bottom',
  HORIZONTAL: 'to right',
};

export const APPEARANCE_BACKGROUND_TABS = {
  SOLID: 'SOLID',
  GRADIENT: 'GRADIENT',
  IMAGE: 'IMAGE',
};

export const BACKGROUND_IMAGE_FIT_MAP = {
  COVER: 'cover',
  CONTAIN: 'contain',
};

export const DEFAULT_FONT_FAMILY = 'Inter Tight';

export const PRIMITIVE_TYPES = {
  STRING: 'string',
  OBJECT: 'object',
  NUMBER: 'number',
};

export const WIDGET_PRO_TYPE = {
  BUTTON: 'BUTTON',
  IMAGE: 'IMAGE',
};

export const POPOVER_HEIGHT = 320;

export const DROP_DOWN = 'DROPDOWN';
export const UPLOAD = 'UPLOAD';
export const TEXT_AREA = 'TEXTAREA';
export const DATE_TYPE = 'DATE';
export const NUMBER = 'NUMBER';
export const EMAIL = 'EMAIL';
export const CONSENT = 'CONSENT';

export const SUCCESS_SCREEN_AUTO_CLOSE = 10000;

export const TRANSITION_DURATION = 400;

export const REDIRECT_EVENT_FLUSH_DELAY = 100;

export const VIEW_KEYS = {
  CTA: 'cta',
  FORM: 'form',
  SUCCESS: 'success',
};

export const FONT_WEIGHTS = {
  BOLD: 700,
  REGULAR: 400,
};

export const WIDGET_PRO_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  DRAFT: 'DRAFT',
};

export const BOOOSTED_WIDGET_PRO_MESSAGE_TYPES = {
  ERROR: 'BOOOSTED_WIDGET_PRO_ERROR',
  HEIGHT: 'BOOOSTED_WIDGET_PRO_HEIGHT',
  SCROLL_TO_TOP: 'BOOOSTED_WIDGET_PRO_SCROLL_TO_TOP',
};

export const SELECT_MENU_SELECTOR = '.select-field__menu';

export const DEFAULT_WIDGET_PADDING = 40;

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const ACTION_TYPES = {
  REDIRECT_URL: 'REDIRECT_URL',
};
